export const FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_REQUEST = 'FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_REQUEST';

export const findPseudonymByModuleAndCareProviderRequest = ({ moduleId, careProviderId }) => ({
    type: FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_REQUEST,
    payload: { moduleId, careProviderId }
});
